import { Box, styled } from '@mui/material';
var StyledModalContentContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    marginTop: theme.spacing(2.5)
  };
  return styles;
});
export { StyledModalContentContainer };